
import * as modals from "@/lib/modals";
import mixin from "./mixin";
import { Component, Mixins } from "vue-property-decorator";

@Component({
  name: modals.customerOnHoldModal
})
export default class CustomerOnHoldModal extends Mixins(mixin) {}
